import apiClient from './apiClient'
import { API_CONFIG } from './config'
import { mockServices, delay } from './mockData'

// Fetch service details
const getServices = async (applicationAPMID) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: services', applicationAPMID)
    return delay(mockServices[1] || [])
  }

  const response = await apiClient.get(`/Service/${applicationAPMID}`)
  return response.data
}

const servicesService = {
  getServices,
}

export default servicesService
